module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('businessDocuments.form_document_scan_title'),
      "icon": "icon-sent",
      "returnUrl": "/home/"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('div', {}, [_c('form', [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('businessDocuments.document_type'),
      "inputType": 'listeSelect',
      "mandatoryErrorIndicator": _vm.fileTypeSelectedError
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileTypeSelected),
      expression: "fileTypeSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('businessDocuments.slct_doct_type')))]), _vm._v(" "), _vm._l((_vm.fileTypeList), function(fileType) {
    return _c('option', {
      key: fileType.fileTypeValue,
      style: (fileType.disabled ? 'font-style:italic;' : ''),
      attrs: {
        "disabled": fileType.disabled
      },
      domProps: {
        "value": fileType.fileTypeValue
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t(fileType.fileTypeLabel)) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('input', {
    ref: "fileButton",
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.executeOCR
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text",
      "id": "recommendation-list-input"
    }
  }), _vm._v(" "), (_vm.fileArrayError) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('errors.is_mandatory', {
    mandatoryValue: _vm.$t('attachments.import_file_singular')
  })) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('b-row', [(this.fileNameArray.length != 0) ? _c('b-col', {
    staticClass: "form-group mt-2",
    attrs: {
      "sm": "12",
      "lg": "12"
    }
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [(this.fileNameArray.length > 1) ? _c('th', {
    staticClass: "border-0"
  }, [_vm._v("Documents scannés")]) : _c('th', {
    staticClass: "border-0"
  }, [_vm._v("Document scanné")]), _vm._v(" "), _c('tbody', _vm._l((this.fileNameArray), function(filename, i) {
    return _c('tr', {
      key: i,
      staticClass: "border-bottom"
    }, [_c('td', {
      staticClass: "border-0 p-1 fs-6 m-0"
    }, [_c('p', {
      staticClass: "d-flex justify-content-between align-items-baseline m-0 p-0"
    }, [_vm._v("\n                        " + _vm._s(i + 1) + "\n                          "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(i)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(filename) + "\n                          ")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(filename)
        }
      }
    }, [_c('i', {
      staticClass: "icon button-delete f7-icons"
    }, [_vm._v("close")])])])])])
  }), 0)])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('div', {
    on: {
      "dragover": _vm.onDragOver
    }
  }, [_c('div', {
    staticClass: "dragDrop dragDropRest d-flex justify-content-center flex-column align-items-center mt-4",
    on: {
      "click": function($event) {
        return _vm.showFileSelectionWindow(_vm.locationTypeFile)
      },
      "drop": _vm.handleDrop,
      "dragover": function($event) {
        $event.preventDefault();
      },
      "dragleave": _vm.onDragLeave
    }
  }, [_c('f7-icon', {
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "fa": "cloud-upload"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-size: 14px text-center"
  }, [_vm._v("Glissez votre fichier ou "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size: 14px"
  }, [_c('u', [_vm._v("Parcourir vos dossiers")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-gray fs-6"
  }, [_c('i', [_vm._v("(formats acceptés pdf, jpg, jpeg, png)")])])])], 1)])])], 1)], 1), _vm._v(" "), (_vm.serialize) ? _c('div', [_vm._l((_vm.serialize), function(element, index) {
    return [_c('form-accordion', {
      key: index,
      staticClass: "mt-2",
      attrs: {
        "title": _vm.fileNameArray[index]
      }
    }, [_c('b-row', [_c('div', {
      staticClass: "spinner-container"
    }, [(!_vm.serialize[index].ocrDone) ? _c('span', {
      staticClass: "spinner-border",
      attrs: {
        "role": "status"
      }
    }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.serializeGet[index]), function(value) {
      return [((value.change === '1' && _vm.serialize[index][value.name] !== '') || (value.change === '0' && _vm.serialize[index][value.name])) ? [(value.type === 'object') ? _vm._l((value[0]), function(subvalue, subindex) {
        return _c('b-col', {
          key: subindex,
          attrs: {
            "sm": "10"
          }
        }, [_c('form-write-group-label-input', {
          attrs: {
            "inputLabel": _vm.$t('businessDocuments.serialize.' + _vm.fileTypeSelectedArray[index] + '.' + subindex.name)
          },
          model: {
            value: (_vm.serialize[index][value.name][0][subindex.name]),
            callback: function($$v) {
              _vm.$set(_vm.serialize[index][value.name][0], subindex.name, $$v)
            },
            expression: "serialize[index][value.name][0][subindex.name]"
          }
        })], 1)
      }) : (value.type === 'date') ? _c('b-col', {
        attrs: {
          "sm": "10"
        }
      }, [_c('form-write-group-label-input', {
        attrs: {
          "inputType": 'date',
          "inputLabel": _vm.$t('businessDocuments.serialize.' + _vm.fileTypeSelectedArray[index] + '.' + value.name),
          "placeholderValue": _vm.$t('common.slct_date')
        },
        model: {
          value: (_vm.serialize[index][value.name]),
          callback: function($$v) {
            _vm.$set(_vm.serialize[index], value.name, $$v)
          },
          expression: "serialize[index][value.name]"
        }
      })], 1) : (value.type === 'boolean' && value.change === '0') ? _c('div', {
        staticClass: "form-group col-sm-10"
      }, [_c('label', [_vm._v(_vm._s(_vm.$t('businessDocuments.serialize.' + _vm.fileTypeSelectedArray[index] + '.' + value.name)))]), _vm._v(" "), (_vm.serialize[index][value.name] === '0') ? _c('div', [_c('i', {
        staticClass: "icon fa fa-check",
        staticStyle: {
          "color": "green",
          "font-size": "30px"
        }
      }), _vm._v("\n                        " + _vm._s(_vm.$t('common.status.valid_control_key')) + "\n                    ")]) : _c('div', [_c('i', {
        staticClass: "icon fa fa-ban",
        staticStyle: {
          "color": "red",
          "font-size": "30px"
        }
      }), _vm._v("  \n                      "), (_vm.serialize[index][value.name] === '1') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.$t('errors.invalid_control_key')) + "\n                      ")]) : (_vm.serialize[index][value.name] === '2') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.$t('errors.out_of_date')) + "\n                      ")]) : (_vm.serialize[index][value.name] === '3') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.$t('errors.invalid_control_key_out_of_date')) + "\n                      ")]) : _vm._e()])]) : _c('b-col', {
        staticClass: "form-group",
        attrs: {
          "sm": "6"
        }
      }, [_c('form-write-group-label-input', {
        attrs: {
          "inputLabel": _vm.$t('businessDocuments.serialize.' + _vm.fileTypeSelectedArray[index] + '.' + value.name)
        },
        model: {
          value: (_vm.serialize[index][value.name]),
          callback: function($$v) {
            _vm.$set(_vm.serialize[index], value.name, $$v)
          },
          expression: "serialize[index][value.name]"
        }
      })], 1)] : _vm._e()]
    })], 2)], 1)]
  })], 2) : _vm._e()])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20448c06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20448c06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/OCRScanTemplate.vue
// module id = 2360
// module chunks = 2